(function () {
  function bindProduct(root) {
    if (!root || root.dataset.bound === '1') return;
    root.dataset.bound = '1';

    var productJson = root.querySelector('[data-product-json]');
    var product = null;
    try {
      product = productJson ? JSON.parse(productJson.textContent) : null;
    } catch (err) {
      product = null;
    }

    var form = root.querySelector('[data-product-form]') || root.querySelector('.main-product__form');
    var variantInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-product-price]');
    var compareEl = root.querySelector('[data-product-compare]');
    var atcBtn = root.querySelector('[data-main-atc]');
    var optionSelects = root.querySelectorAll('[data-option-select]');
    var qtyInput = root.querySelector('[data-quantity-input]');
    var shopPay = root.querySelector('[data-shop-pay]');
    /* No size chosen for the visitor (owner, 25 Oct 2026, as on Sableau): a size
       is marked only after a tap, or when the URL named a variant. Until then the
       buy buttons send the visitor to the sizes instead of adding the first one. */
    var sizeOption = root.querySelector('.main-product__option--size');
    var sizeButtons = sizeOption ? sizeOption.querySelectorAll('[data-option-size]') : [];
    var sizePicked = sizeButtons.length < 2 || !!root.querySelector('[data-option-size].is-selected');
    /* EU size buttons (docs/SIZE_CHARTS.md) can stand for the same maker size, so
       the button tapped is remembered by its EU size, not only by its value. */
    var euPicked = sizeOption && sizeOption.querySelector('[data-option-size][data-eu].is-selected');
    euPicked = euPicked ? euPicked.getAttribute('data-eu') : '';
    sizeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        /* A second tap on the chosen size clears it again (owner, 25 Oct 2026);
           the option keeps its value, only the visible choice goes. */
        sizePicked = !(sizeButtons.length > 1 && btn.classList.contains('is-selected'));
        euPicked = btn.getAttribute('data-eu') || '';
        if (sizeOption) sizeOption.classList.remove('is-missing');
      });
    });

    /* The sticky bar names the size the visitor tapped (EU), not the maker's
       label behind it: "M / Black", not "2XL / Black" (docs/SIZE_CHARTS.md). */
    function euTitle(v) {
      var btn = euPicked && sizeOption ? sizeOption.querySelector('[data-option-size][data-eu].is-selected') : null;
      if (!btn || !v.options) return v.title;
      var maker = btn.getAttribute('data-value');
      return v.options.map(function (o) { return o === maker ? btn.getAttribute('data-eu') : o; }).join(' / ');
    }

    // "2XL" is XXL and "XL · 34" is XL: the same size, so nothing extra is said.
    function sameSize(a, b) {
      function norm(size) { return String(size || '').split('·')[0].trim().toUpperCase().replace(/^2XL$/, 'XXL'); }
      return norm(a) === norm(b);
    }

    /* Line item properties for an EU size: _eu always (hidden at checkout), and
       "EU size" with the label size only when the label says something else. */
    function euProps(eu, maker, advice) {
      if (!eu) return null;
      var props = { _eu: eu };
      if (!sameSize(eu, maker)) {
        props['EU size'] = eu;
        props['_label size'] = maker;
      }
      // What the size help was told and advised (owner, 26 Oct 2026); a line without the finder says so.
      props._size_advice = advice || (window.Belnay && window.Belnay.sizeAdvicePlain ? window.Belnay.sizeAdvicePlain(eu, maker) : 'chose ' + eu + ' · label ' + maker + ' · finder not opened');
      return props;
    }
    function pageAdvice() {
      return window.Belnay && window.Belnay.sizeAdvice ? window.Belnay.sizeAdvice(root) : '';
    }

    function euMap(raw) {
      try {
        var list = JSON.parse(raw || 'null');
        return Array.isArray(list) && list.length ? list : null;
      } catch (err) {
        return null;
      }
    }

    // The EU size a bundle line shows: its size select's chosen option.
    function lineEu(line) {
      var opt = line && line.querySelector('[data-line-option] option[data-eu]:checked');
      return opt ? { eu: opt.getAttribute('data-eu'), maker: opt.value } : null;
    }
    function askForSize() {
      if (!sizeOption) return;
      sizeOption.classList.add('is-missing');
      sizeOption.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
      var current = sizeOption.querySelector('[data-option-size].is-selected') || sizeButtons[0];
      if (current) current.focus({ preventScroll: true });
    }
    function squareWalletButtons() {
      root.querySelectorAll('shopify-accelerated-checkout').forEach(function (el) {
        el.style.setProperty('--shopify-accelerated-checkout-button-border-radius', '3px');
        el.style.setProperty('--shopify-accelerated-checkout-button-block-size', '3.1rem');
        el.style.setProperty('--shopify-accelerated-checkout-button-box-shadow', 'none');
      });
    }
    squareWalletButtons();
    if (shopPay && window.MutationObserver) {
      new MutationObserver(squareWalletButtons).observe(shopPay, { childList: true, subtree: true });
    }
    var moneyFormat = root.getAttribute('data-money-format') || '{{amount}}';
    var addLabel = root.getAttribute('data-add-label') || 'Add to cart';
    var soldLabel = root.getAttribute('data-sold-label') || 'Sold out';
    var youSaveLabel = root.getAttribute('data-you-save') || 'You save {percent}%';
    var saleBadgeLabel = root.getAttribute('data-sale-badge') || '-{percent}%';
    /* Percent off the whole bundle from 2 pieces (automatic discount in Admin). */
    var bundleOff = parseFloat(root.getAttribute('data-bundle-off') || '0') || 0;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function selectedOptions() {
      var values = product && product.options
        ? product.options.map(function () { return ''; })
        : [];
      optionSelects.forEach(function (sel) {
        var idx = parseInt(sel.getAttribute('data-option-index'), 10);
        if (isNaN(idx)) values.push(sel.value);
        else values[idx] = sel.value;
      });
      return values;
    }

    function findVariant(opts) {
      if (!product) return null;
      var values = opts || selectedOptions();
      return product.variants.find(function (v) {
        return values.every(function (opt, i) { return v.options[i] === opt; });
      }) || null;
    }

    // PDP prices show without the currency sign, as Sableau's do (owner, 30 Oct 2026).
    function formatMoney(cents) {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, moneyFormat).replace(/^[^\d-]+/, '');
      }
      return (Number(cents) / 100).toFixed(2).replace('.', ',');
    }

    function savePercent(price, compare) {
      if (!compare || compare <= price) return 0;
      return Math.round(((compare - price) / compare) * 100);
    }

    function optionAvailable(optionIndex, value) {
      if (!product) return true;
      var opts = selectedOptions();
      return product.variants.some(function (v) {
        if (v.available === false) return false;
        return v.options.every(function (opt, i) {
          if (i === optionIndex) return opt === value;
          return opts[i] === opt;
        });
      });
    }

    function mediaIdForVariant(variant) {
      if (!variant) return null;
      if (variant.featured_media && variant.featured_media.id) return String(variant.featured_media.id);
      if (variant.featured_image && variant.featured_image.id) return String(variant.featured_image.id);
      return null;
    }

    function variantImage(variant) {
      if (!variant) return '';
      var img = variant.featured_image;
      var src = '';
      if (img && img.src) src = img.src;
      else if (variant.featured_media && variant.featured_media.preview_image) {
        src = variant.featured_media.preview_image.src || '';
      }
      if (src && window.belnayStudioSrc) return window.belnayStudioSrc(src);
      return src;
    }

    var jumpToFirstPhoto = false;

    function setOptionValue(index, value, fromUi) {
      var select = root.querySelector('[data-option-select][data-option-index="' + index + '"]') || optionSelects[index];
      if (!select) return;
      if (select.getAttribute('data-option-role') === 'color') jumpToFirstPhoto = true;
      select.value = value;
      if (!fromUi) {
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function paintOptionUi() {
      root.querySelectorAll('[data-option-swatch]').forEach(function (swatch) {
        var idx = parseInt(swatch.getAttribute('data-option-index'), 10);
        var value = swatch.getAttribute('data-value');
        var on = optionSelects[idx] && optionSelects[idx].value === value;
        swatch.classList.toggle('is-selected', on);
        swatch.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      root.querySelectorAll('[data-option-size]').forEach(function (btn) {
        var idx = parseInt(btn.getAttribute('data-option-index'), 10);
        var value = btn.getAttribute('data-value');
        var on = sizePicked && optionSelects[idx] && optionSelects[idx].value === value &&
          (!btn.hasAttribute('data-eu') || btn.getAttribute('data-eu') === euPicked);
        btn.classList.toggle('is-selected', on);
        btn.classList.toggle('is-unavailable', !optionAvailable(idx, value));
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var colorVal = root.querySelector('[data-color-value]');
      var colorSelect = root.querySelector('.main-product__option--color [data-option-select], [data-option-role="color"]');
      if (colorVal && colorSelect) colorVal.textContent = colorSelect.value;
      placeSizePills();
      paintEu();
    }

    /* After a pick: "XL fits close." when that EU size only just fits, and the
       hidden properties the accelerated checkout reads from the form. */
    function paintEu() {
      var btn = sizePicked && sizeOption ? sizeOption.querySelector('[data-option-size][data-eu].is-selected') : null;
      var close = root.querySelector('[data-eu-close]');
      if (close) {
        close.hidden = !(btn && btn.hasAttribute('data-close'));
        if (btn) close.textContent = (close.getAttribute('data-text') || '').replace('{size}', btn.getAttribute('data-eu'));
      }
      var props = (btn && euProps(btn.getAttribute('data-eu'), btn.getAttribute('data-value'))) || {};
      root.querySelectorAll('[data-eu-prop]').forEach(function (input) {
        var key = input.getAttribute('data-eu-prop');
        input.value = props[key] || '';
        input.disabled = !props[key];
      });
    }

    function placeSizePills() {
      root.querySelectorAll('[data-size-row]').forEach(function (row) {
        var pill = row.querySelector('[data-size-pill]');
        var selected = row.querySelector('[data-option-size].is-selected');
        if (!pill) return;
        if (!selected) {
          pill.hidden = true;
          return;
        }
        pill.hidden = false;
        var rowRect = row.getBoundingClientRect();
        var rect = selected.getBoundingClientRect();
        var instant = row.getAttribute('data-pill-ready') !== '1' || reduced;
        if (instant) pill.style.transition = 'none';
        pill.style.width = rect.width + 'px';
        pill.style.height = rect.height + 'px';
        pill.style.transform = 'translate3d(' + (rect.left - rowRect.left) + 'px,' + (rect.top - rowRect.top) + 'px,0)';
        if (row.getAttribute('data-pill-ready') !== '1') {
          pill.offsetWidth;
          pill.style.transition = '';
          row.setAttribute('data-pill-ready', '1');
        } else if (reduced) {
          pill.style.transition = 'none';
        } else {
          pill.style.transition = '';
        }
      });
    }

    function paintPrices(variant) {
      if (!variant) return;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price > variant.price) {
          compareEl.hidden = false;
          compareEl.textContent = formatMoney(variant.compare_at_price);
        } else {
          compareEl.hidden = true;
          compareEl.textContent = '';
        }
      }
      root.querySelectorAll('[data-bundle-tier]').forEach(function (tier) {
        var priceNode = tier.querySelector('[data-bundle-price]');
        var compareNode = tier.querySelector('[data-bundle-compare]');
        var saveNode = tier.querySelector('[data-bundle-save]');
        var quote = tierQuote(tier, variant);
        var livePrice = quote.price;
        var liveCompare = quote.compare;
        if (priceNode) priceNode.textContent = formatMoney(livePrice);
        if (compareNode) {
          if (liveCompare > livePrice) {
            compareNode.hidden = false;
            compareNode.textContent = formatMoney(liveCompare);
          } else {
            compareNode.hidden = true;
          }
        }
        if (saveNode) {
          var pct = savePercent(livePrice, liveCompare);
          if (pct > 0) {
            saveNode.hidden = false;
            saveNode.textContent = youSaveLabel.replace('{percent}', String(pct));
          } else {
            saveNode.hidden = true;
          }
        }
      });
      var salePct = variant.available === false ? 0 : savePercent(variant.price, variant.compare_at_price);
      root.querySelectorAll('[data-sale-badge]').forEach(function (badge) {
        if (variant.available === false) {
          badge.hidden = false;
          badge.textContent = soldLabel;
        } else if (salePct > 0) {
          badge.hidden = false;
          badge.textContent = saleBadgeLabel.replace('{percent}', String(salePct));
        } else {
          badge.hidden = true;
          badge.textContent = '';
        }
      });
    }

    var allowMediaScroll = false;
    var galleryTrack = root.querySelector('[data-gallery-track]');
    var galleryMoved = false;
    var galleryIndex = 0;
    var galleryDrag = null;
    var coarsePointer = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;

    function phoneGallery() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function gallerySlides() {
      return galleryTrack ? galleryTrack.querySelectorAll('[data-gallery-slide]:not([hidden])') : [];
    }

    function frameWidth() {
      var gallery = galleryTrack && (galleryTrack.closest('[data-product-gallery]') || galleryTrack.parentElement);
      var width = gallery ? gallery.clientWidth : 0;
      if (!width && galleryTrack) width = galleryTrack.clientWidth;
      return width || 1;
    }

    function clearSlideSizes() {
      gallerySlides().forEach(function (slide) {
        slide.style.flexBasis = '';
        slide.style.width = '';
      });
    }

    /* A phone photo takes --gallery-slide of the frame (CSS owns the share),
       so the next one peeks in beside it, as on icon-amsterdam.com. */
    function slideWidth() {
      var share = parseFloat(getComputedStyle(galleryTrack).getPropertyValue('--gallery-slide')) / 100 || 1;
      return Math.round(frameWidth() * share);
    }

    function galleryGap() {
      return parseFloat(getComputedStyle(galleryTrack).columnGap) || 0;
    }

    function slideStep() {
      return slideWidth() + galleryGap();
    }

    /* The last photo stops flush right, as a scroller would, not with an
       empty strip after it. */
    function slideOffset(index, step) {
      var end = Math.max(0, gallerySlides().length * step - galleryGap() - frameWidth());
      return -Math.min(index * step, end);
    }

    function layoutSlides() {
      var width = slideWidth();
      gallerySlides().forEach(function (slide) {
        slide.style.flexBasis = width + 'px';
        slide.style.width = width + 'px';
      });
      return width + galleryGap();
    }

    function warmSlides(index) {
      var slides = gallerySlides();
      /* Neighbours of the first photo wait until it is in, so it gets the
         whole connection on a slow phone. */
      var first = slides[0] && slides[0].querySelector('img');
      /* A colour tap can move a still-lazy photo to the front; lazy stays
         display: none on a phone, so waiting on it left a white frame. */
      if (first && first.loading === 'lazy') first.loading = 'eager';
      if (index === 0 && first && !first.complete) {
        first.addEventListener('load', function () { warmSlides(0); }, { once: true });
        first.addEventListener('error', function () { warmSlides(0); }, { once: true });
        return;
      }
      for (var i = 0; i < slides.length; i++) {
        if (Math.abs(i - index) > 1) continue;
        var img = slides[i].querySelector('img');
        if (!img) continue;
        if (img.loading === 'lazy') img.loading = 'eager';
      }
    }

    function paintGallery(index, animate) {
      if (!galleryTrack) return;
      var slides = gallerySlides();
      var max = Math.max(0, slides.length - 1);
      if (index < 0) index = 0;
      if (index > max) index = max;
      galleryIndex = index;
      root.querySelectorAll('[data-gallery-dot]').forEach(function (dot, i) {
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      if (!phoneGallery()) {
        clearSlideSizes();
        galleryTrack.style.transform = '';
        galleryTrack.style.transition = '';
        return;
      }
      /* Laying the filmstrip out while the photo is still moving
         restretches that bitmap and the phone animation hitches. */
      if (document.documentElement.dataset.vt === '1') return;
      var step = layoutSlides();
      galleryTrack.style.transition = animate && !reduced ? 'transform 320ms ease' : 'none';
      galleryTrack.style.transform = 'translate3d(' + slideOffset(index, step) + 'px,0,0)';
      warmSlides(index);
    }

    function setGallerySwipeLock(on) {
      document.documentElement.classList.toggle('is-gallery-swiping', !!on);
    }

    function noteGalleryAxis(dx, dy) {
      if (!galleryDrag || galleryDrag.axis) return galleryDrag && galleryDrag.axis;
      if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return null;
      galleryDrag.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      if (galleryDrag.axis === 'x') setGallerySwipeLock(true);
      return galleryDrag.axis;
    }

    function moveGallery(dx) {
      var width = galleryDrag.width || slideStep();
      var maxIndex = Math.max(0, gallerySlides().length - 1);
      var x = slideOffset(galleryIndex, width) + dx;
      var min = slideOffset(maxIndex, width);
      if (x > 0) x = Math.min(72, x) * 0.35;
      else if (x < min) x = min + Math.max(-72, x - min) * 0.35;
      galleryTrack.style.transition = 'none';
      galleryTrack.style.transform = 'translate3d(' + x + 'px,0,0)';
    }

    function onGalleryTouchMove(event) {
      if (!galleryDrag || !phoneGallery()) return;
      var touch = event.touches && event.touches[0];
      if (!touch) return;
      var axis = noteGalleryAxis(touch.clientX - galleryDrag.x, touch.clientY - galleryDrag.y);
      if (axis === 'x' && event.cancelable) event.preventDefault();
    }

    function endGalleryDrag(event) {
      if (!galleryDrag) return;
      if (event && event.pointerId != null && galleryDrag.pointerId != null && event.pointerId !== galleryDrag.pointerId) return;
      var axis = galleryDrag.axis;
      var width = galleryDrag.width || slideStep();
      var origin = galleryDrag.x;
      var useFinger = event && event.type !== 'pointercancel' && typeof event.clientX === 'number';
      var dx = 0;
      if (useFinger) {
        dx = event.clientX - origin;
      } else {
        var match = /translate3d\(\s*(-?[\d.]+)px/i.exec(galleryTrack.style.transform || '');
        var translated = match ? parseFloat(match[1]) || 0 : slideOffset(galleryIndex, width);
        dx = translated - slideOffset(galleryIndex, width);
      }
      galleryDrag = null;
      window.removeEventListener('pointermove', onWindowPointerMove);
      window.removeEventListener('pointerup', endGalleryDrag);
      window.removeEventListener('pointercancel', endGalleryDrag);
      document.removeEventListener('touchmove', onGalleryTouchMove);
      setGallerySwipeLock(false);
      if (!phoneGallery() || axis !== 'x') {
        paintGallery(galleryIndex, false);
        return;
      }
      var next = galleryIndex;
      if (dx <= -width * 0.15) next += 1;
      else if (dx >= width * 0.15) next -= 1;
      paintGallery(next, true);
    }

    function onWindowPointerMove(event) {
      if (!galleryDrag || event.pointerId !== galleryDrag.pointerId || !phoneGallery()) return;
      var dx = event.clientX - galleryDrag.x;
      var dy = event.clientY - galleryDrag.y;
      var axis = noteGalleryAxis(dx, dy);
      if (axis !== 'x') return;
      galleryMoved = true;
      if (event.cancelable) event.preventDefault();
      moveGallery(dx);
    }

    if (galleryTrack) {
      galleryTrack.addEventListener('pointerdown', function (event) {
        if (!phoneGallery()) return;
        if (event.button != null && event.button !== 0) return;
        galleryMoved = false;
        galleryDrag = {
          pointerId: event.pointerId,
          x: event.clientX,
          y: event.clientY,
          axis: null,
          width: slideStep()
        };
        window.addEventListener('pointermove', onWindowPointerMove, { passive: false });
        window.addEventListener('pointerup', endGalleryDrag);
        window.addEventListener('pointercancel', endGalleryDrag);
        document.addEventListener('touchmove', onGalleryTouchMove, { passive: false });
      });
      galleryTrack.addEventListener('touchmove', onGalleryTouchMove, { passive: false });
      window.addEventListener('resize', function () {
        paintGallery(galleryIndex, false);
        placeSizePills();
      });
      root.querySelectorAll('[data-gallery-dot]').forEach(function (dot, i) {
        dot.addEventListener('click', function () { paintGallery(i, true); });
      });
      paintGallery(0, false);
      document.addEventListener('belnay:vt-done', function () {
        paintGallery(galleryIndex, false);
      });
    } else {
      window.addEventListener('resize', placeSizePills);
    }

    /* A colour click shows that colour's photos, in their order (owner, 31 Oct
       2026); the page itself stays put (owner, 25 Oct 2026: only the photo may move). */
    function finishColorJump(jump) {
      if (!jump) return;
      requestAnimationFrame(function () {
        jumpToFirstPhoto = false;
      });
    }

    function colorOfSlide(slide) {
      return slide ? (slide.getAttribute('data-color') || '') : '';
    }

    /* The photos to show for the chosen colour, in order: its own series, or
       its one photo followed by the photos without a colour. The variant's
       photo leads. */
    function visibleSlides(variant) {
      var all = Array.prototype.slice.call(galleryTrack.querySelectorAll('[data-gallery-slide]'));
      var sel = root.querySelector('[data-option-role="color"]');
      var color = sel ? sel.value : '';
      var own = all.filter(function (slide) { return color !== '' && colorOfSlide(slide) === color; });
      /* ponytail: one tagged photo is the old swatch image, not a series; a series is 2+ (5 when complete). */
      var shown = own.length >= 2 ? own : own.concat(all.filter(function (slide) { return !colorOfSlide(slide); }));
      if (!shown.length) shown = all;
      var id = mediaIdForVariant(variant);
      var lead = id ? shown.filter(function (slide) { return slide.getAttribute('data-media-id') === String(id); })[0] : null;
      /* The page opens on the photo set first in Shopify admin, as the card
         does; the variant's photo leads only when the colour changes. */
      var hero = gallerySlides()[0];
      var heroHasColor = color !== '' && colorOfSlide(hero) === color;
      if (lead && lead !== shown[0] && !heroHasColor) shown = [lead].concat(shown.filter(function (slide) { return slide !== lead; }));
      return { all: all, shown: shown };
    }

    function revealVariantMedia(variant) {
      var jump = jumpToFirstPhoto;
      if (!allowMediaScroll || !galleryTrack) {
        jumpToFirstPhoto = false;
        return;
      }
      var set = visibleSlides(variant);
      var slides = Array.prototype.slice.call(gallerySlides());
      var same = slides.length === set.shown.length && slides.every(function (node, i) { return node === set.shown[i]; });
      if (same) {
        finishColorJump(jump);
        return;
      }
      var slide = set.shown[0];

      var gallery = galleryTrack.closest('[data-product-gallery]') || galleryTrack.parentElement;
      var phone = phoneGallery();
      var source = phone ? (slides[galleryIndex] || slides[0]) : slides[0];
      var sourceImg = source && source.querySelector('img');
      var ghost = null;
      if (sourceImg && gallery && !reduced && slide !== slides[0]) {
        var oldGhost = gallery.querySelector('[data-color-ghost]');
        if (oldGhost) oldGhost.remove();
        ghost = sourceImg.cloneNode(true);
        ghost.removeAttribute('id');
        ghost.setAttribute('alt', '');
        ghost.setAttribute('aria-hidden', 'true');
        ghost.setAttribute('data-color-ghost', '');
        var top = '0px';
        var left = '0px';
        var width = '100%';
        var height = '100%';
        if (!phone && slides[0]) {
          var host = gallery.getBoundingClientRect();
          var rect = slides[0].getBoundingClientRect();
          top = (rect.top - host.top) + 'px';
          left = (rect.left - host.left) + 'px';
          width = rect.width + 'px';
          height = rect.height + 'px';
        }
        /* Same fit as the photo it covers: a phone photo is contained in a 3:2 box, and cover flashed it zoomed in. */
        var fit = getComputedStyle(sourceImg).objectFit || 'cover';
        ghost.style.cssText = 'position:absolute;top:' + top + ';left:' + left + ';width:' + width + ';height:' + height + ';object-fit:' + fit + ';z-index:4;pointer-events:none;margin:0;opacity:1;transition:opacity 250ms ease-in-out;';
        gallery.appendChild(ghost);
      }

      var scrollX = window.scrollX;
      var scrollY = window.scrollY;
      /* Shown photos first in the DOM, so the first slide is always the hero. */
      var rest = set.all.filter(function (node) { return set.shown.indexOf(node) === -1; });
      set.shown.concat(rest).forEach(function (node) {
        node.hidden = rest.indexOf(node) !== -1;
        galleryTrack.appendChild(node);
      });
      if (window.scrollX !== scrollX || window.scrollY !== scrollY) window.scrollTo(scrollX, scrollY);

      var next = gallerySlides();
      root.querySelectorAll('[data-gallery-dot]').forEach(function (dot, i) {
        dot.parentElement.hidden = i >= next.length;
      });
      zoomSlides.forEach(function (zoomSlide, i) {
        var on = set.shown.some(function (node) { return node.getAttribute('data-media-id') === zoomSlide.getAttribute('data-media-id'); });
        zoomSlide.hidden = !on;
        if (zoomThumbs[i]) zoomThumbs[i].hidden = !on;
      });
      for (var n = 0; n < next.length; n++) {
        next[n].setAttribute('data-gallery-index', String(n));
        if (n === 0) {
          next[n].id = 'ProductPhoto';
          next[n].setAttribute('data-view-transition-type', 'product-image-transition');
          next[n].classList.add('main-product__slide--hero');
        } else {
          if (next[n].id === 'ProductPhoto') next[n].removeAttribute('id');
          next[n].removeAttribute('data-view-transition-type');
          next[n].classList.remove('main-product__slide--hero');
        }
      }
      if (phone) paintGallery(0, false);
      finishColorJump(jump);

      if (!ghost) return;
      function fadeGhost() {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            ghost.style.opacity = '0';
          });
        });
        window.setTimeout(function () {
          if (ghost.parentNode) ghost.parentNode.removeChild(ghost);
        }, 280);
      }
      /* On a slow phone the new photo takes a second; the old one stays
         over the frame until it is in, so the frame never shows empty. */
      var heroImg = slide.querySelector('img');
      if (heroImg && !heroImg.complete) {
        heroImg.addEventListener('load', fadeGhost, { once: true });
        heroImg.addEventListener('error', fadeGhost, { once: true });
        /* Never leave the old colour's photo up if neither event comes. */
        window.setTimeout(fadeGhost, 4000);
      } else {
        fadeGhost();
      }
    }

    function currentBundleQty() {
      var selected = root.querySelector('[data-bundle-tier].is-selected');
      return selected ? parseInt(selected.getAttribute('data-bundle-qty'), 10) || 1 : 1;
    }

    function lineSelects(line) {
      return line ? line.querySelectorAll('[data-line-option]') : [];
    }

    var peerCache = {};

    function asPeer(raw) {
      if (!raw) return null;
      var names = raw.optionNames || raw.options || [];
      if (names.length && typeof names[0] !== 'string') {
        names = names.map(function (opt) { return opt && (opt.name || opt); });
      }
      var variants = (raw.variants || []).map(function (item) {
        var options = item.options && typeof item.options[0] === 'string'
          ? item.options.slice()
          : [item.option1, item.option2, item.option3].filter(function (value) { return value != null && value !== ''; });
        var image = '';
        if (typeof item.image === 'string') image = item.image;
        else if (typeof item.featured_image === 'string') image = item.featured_image;
        else if (item.featured_image && item.featured_image.src) image = item.featured_image.src;
        return {
          id: item.id,
          options: options,
          available: item.available !== false,
          price: Number(item.price) || 0,
          compare: Number(item.compare || item.compare_at_price || 0) || 0,
          featured_image: image ? { src: image } : null
        };
      });
      var image = '';
      if (typeof raw.image === 'string') image = raw.image;
      else if (typeof raw.featured_image === 'string') image = raw.featured_image;
      else if (raw.featured_image && raw.featured_image.src) image = raw.featured_image.src;
      else if (raw.images && raw.images[0]) image = typeof raw.images[0] === 'string' ? raw.images[0] : (raw.images[0].src || '');
      return {
        id: raw.id,
        handle: raw.handle,
        title: raw.title,
        url: raw.url || ('/products/' + raw.handle),
        image: image,
        optionNames: names,
        variants: variants
      };
    }

    function rememberPeer(raw) {
      var peer = asPeer(raw);
      if (peer && peer.handle) peerCache[peer.handle] = peer;
      return peer;
    }

    if (product) {
      var pagePeer = rememberPeer(product);
      if (pagePeer) pagePeer.eu = euMap(root.getAttribute('data-eu-map'));
    }

    function loadPeer(handle) {
      if (peerCache[handle]) return Promise.resolve(peerCache[handle]);
      return fetch('/products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        if (!response.ok) throw new Error('peer');
        return response.json();
      }).then(rememberPeer);
    }

    function peerForLine(line) {
      var handle = line && line.getAttribute('data-line-product');
      if (handle && peerCache[handle]) return peerCache[handle];
      if (product && (!handle || handle === product.handle)) return peerCache[product.handle] || null;
      return null;
    }

    function variantFromLine(line) {
      var peer = peerForLine(line);
      if (!line || !peer) return findVariant();
      var opts = [];
      lineSelects(line).forEach(function (sel) {
        var idx = parseInt(sel.getAttribute('data-option-index'), 10);
        if (!isNaN(idx)) opts[idx] = sel.value;
      });
      var match = (peer.variants || []).find(function (item) {
        return opts.every(function (value, index) {
          return value == null || item.options[index] === value;
        });
      });
      return match || (peer.variants || []).find(function (item) { return item.available; }) || (peer.variants || [])[0] || findVariant();
    }

    function optionLabel(name) {
      var key = String(name || '').toLowerCase();
      if (/size|maat|shoe|schuh|größ|gros/.test(key)) return root.getAttribute('data-label-size') || name;
      if (/color|colour|kleur|farbe/.test(key)) return root.getAttribute('data-label-colour') || name;
      return name;
    }

    function chooseVariant(peer, prefer) {
      var variants = (peer && peer.variants) || [];
      var names = (peer && peer.optionNames) || [];
      function wanted(index) {
        if (!prefer) return null;
        if (Array.isArray(prefer)) return prefer[index] == null ? null : prefer[index];
        var name = String(names[index] || '').toLowerCase();
        if (prefer[name] != null) return prefer[name];
        var keys = Object.keys(prefer);
        var key = '';
        if (/size|maat|shoe|schuh|größ|gros/.test(name)) {
          key = keys.find(function (item) { return /size|maat|shoe|schuh|größ|gros/.test(item); }) || '';
        } else if (/color|colour|kleur|farbe/.test(name)) {
          key = keys.find(function (item) { return /color|colour|kleur|farbe/.test(item); }) || '';
        }
        return key ? prefer[key] : null;
      }
      var same = variants.find(function (item) {
        return item.available && names.every(function (_, index) {
          var value = wanted(index);
          return value == null || item.options[index] === value;
        });
      });
      if (same) return same;
      var sizeIdx = names.findIndex(function (name) {
        return /size|maat|shoe|schuh|größ|gros/.test(String(name || ''));
      });
      var sizeValue = sizeIdx >= 0 ? wanted(sizeIdx) : null;
      if (sizeValue) {
        var sized = variants.find(function (item) {
          return item.available && item.options[sizeIdx] === sizeValue;
        });
        if (sized) return sized;
      }
      return variants.find(function (item) { return item.available; }) || variants[0];
    }

    /* Shopify rounds the discount per piece down (cents). */
    function pieceAfterOff(unit) {
      return unit - Math.floor(unit * bundleOff / 100);
    }

    function tierQuote(tier, fallback) {
      var units = [];
      var compare = 0;
      tier.querySelectorAll('[data-bundle-line]').forEach(function (line) {
        var index = parseInt(line.getAttribute('data-bundle-line'), 10) || 1;
        var qty = parseInt(tier.getAttribute('data-bundle-qty'), 10) || 1;
        if (index > qty) return;
        var picked = variantFromLine(line) || fallback;
        if (!picked) return;
        var unit = Number(picked.price);
        if (isNaN(unit)) unit = fallback.price;
        var was = Number(picked.compare || picked.compare_at_price || 0) || 0;
        if (!(was > unit)) was = unit;
        compare += was;
        units.push({ index: index, unit: unit });
      });
      var price = 0;
      if (!units.length) {
        var qty = parseInt(tier.getAttribute('data-bundle-qty'), 10) || 1;
        var fallbackWas = fallback.compare_at_price || 0;
        price = (qty > 1 ? pieceAfterOff(fallback.price) : fallback.price) * qty;
        compare = (fallbackWas > fallback.price ? fallbackWas : fallback.price) * qty;
        return { price: price, compare: compare };
      }
      units.forEach(function (item) {
        price += units.length > 1 ? pieceAfterOff(item.unit) : item.unit;
      });
      return { price: price, compare: compare };
    }

    function bundleLinesAvailable() {
      var tier = selectedTierRoot();
      var qty = currentBundleQty();
      var ok = true;
      tier.querySelectorAll('[data-bundle-line]').forEach(function (line) {
        var index = parseInt(line.getAttribute('data-bundle-line'), 10) || 1;
        if (index > qty) return;
        var picked = variantFromLine(line);
        if (picked && picked.available === false) ok = false;
      });
      return ok;
    }

    function markSelectedPeer(handle) {
      root.querySelectorAll('[data-bundle-peer]').forEach(function (btn) {
        var on = btn.getAttribute('data-bundle-peer') === handle;
        btn.classList.toggle('is-selected', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function renderLineOptions(line, peer, variant, pick) {
      var picks = line.querySelector('[data-line-picks]');
      if (!picks) return;
      picks.innerHTML = '';
      (peer.optionNames || []).forEach(function (name, idx) {
        if (String(name || '').toLowerCase() === 'title') return;
        var sel = document.createElement('select');
        sel.setAttribute('data-line-option', '');
        sel.setAttribute('data-option-index', String(idx));
        sel.setAttribute('aria-label', optionLabel(name));
        var values = [];
        (peer.variants || []).forEach(function (item) {
          var val = item.options[idx];
          if (val && values.indexOf(val) === -1) values.push(val);
        });
        // A piece with EU sizes lists those, each standing for its maker size.
        // A row labelled "XL · 34" is the option "XL".
        var optionOf = function (maker) { return values.indexOf(maker) !== -1 ? maker : String(maker).split('·')[0].trim(); };
        var eu = peer.eu && /size|maat/i.test(String(name || ''))
          ? peer.eu.filter(function (entry) { return values.indexOf(optionOf(entry.maker)) !== -1; })
          : [];
        var marked = false;
        (eu.length ? eu : values).forEach(function (val) {
          var opt = document.createElement('option');
          var maker = typeof val === 'string' ? val : optionOf(val.maker);
          opt.value = maker;
          opt.textContent = typeof val === 'string' ? val : val.size;
          if (typeof val !== 'string') opt.setAttribute('data-eu', val.size);
          if (!marked && variant && variant.options[idx] === maker && (typeof val === 'string' || !pick || val.size === pick)) {
            opt.selected = true;
            marked = true;
          }
          sel.appendChild(opt);
        });
        picks.appendChild(sel);
      });
    }

    // A size preference in the new piece's maker size, found by the EU size shown.
    function preferSize(prefer, maker) {
      Object.keys(prefer || {}).forEach(function (key) {
        if (!/size|maat|shoe|schuh|größ|gros/.test(key)) return;
        if (maker) prefer[key] = maker;
        else delete prefer[key];
      });
      return prefer;
    }

    function applyToLine(line, peer, variant, pick) {
      if (!line || !peer || !variant) return;
      line.setAttribute('data-line-product', peer.handle);
      var name = line.querySelector('[data-line-name]');
      if (name) name.textContent = peer.title;
      var trigger = line.querySelector('[data-quick-view-open]');
      if (trigger) {
        trigger.setAttribute('data-product-url', peer.url);
        var viewLabel = root.getAttribute('data-bundle-view') || 'View [[title]]';
        trigger.setAttribute('aria-label', viewLabel.replace('[[title]]', peer.title));
      }
      renderLineOptions(line, peer, variant, pick);
      paintLine(line, variant);
      var index = parseInt(line.getAttribute('data-bundle-line'), 10) || 1;
      if (index === 2) markSelectedPeer(peer.handle);
      if (index === 1 && product && peer.handle === product.handle) {
        if (pick) euPicked = pick;
        (variant.options || []).forEach(function (val, idx) {
          setOptionValue(idx, val, false);
        });
        return;
      }
      updateVariant();
    }

    function paintLine(line, variant) {
      if (!line || !variant) return;
      var img = line.querySelector('[data-line-thumb]');
      var src = variantImage(variant);
      // The thumb shows at 80 px; ask the CDN for the same 160 px the page rendered.
      if (/\/cdn\/shop\/files\//.test(src)) src += (src.indexOf('?') === -1 ? '?' : '&') + 'width=160';
      else if (/\/assets\/g-/.test(src)) src = src.replace(/(\.[a-z0-9]+)(\?|$)/i, '_160x$1$2');
      if (img && src) {
        if (img.getAttribute('src') !== src) {
          img.removeAttribute('data-ground-ready');
          img.removeAttribute('data-ground-busy');
          img.removeAttribute('srcset');
        }
        img.src = src;
        img.removeAttribute('hidden');
      }
      lineSelects(line).forEach(function (sel) {
        var idx = parseInt(sel.getAttribute('data-option-index'), 10);
        if (!isNaN(idx) && variant.options[idx]) sel.value = variant.options[idx];
      });
    }

    function syncBundleLines(variant) {
      var qty = currentBundleQty();
      root.querySelectorAll('[data-bundle-line]').forEach(function (line) {
        var index = parseInt(line.getAttribute('data-bundle-line'), 10) || 1;
        line.hidden = index > qty;
        var handle = line.getAttribute('data-line-product');
        var pagePiece = !handle || !product || handle === product.handle;
        if (pagePiece && index === 1) paintLine(line, variant);
        else if (!line.hidden) paintLine(line, variantFromLine(line) || variant);
      });
    }

    function syncPageLines(idx, value, eu) {
      root.querySelectorAll('[data-bundle-line="1"]').forEach(function (line) {
        var handle = line.getAttribute('data-line-product');
        if (handle && product && handle !== product.handle) return;
        var sel = line.querySelector('[data-line-option][data-option-index="' + idx + '"]');
        if (!sel) return;
        var opt = eu && sel.querySelector('option[data-eu="' + eu.replace(/"/g, '') + '"]');
        if (opt) opt.selected = true;
        else sel.value = value;
      });
    }

    function linePreference(line) {
      var peer = peerForLine(line);
      var named = {};
      lineSelects(line).forEach(function (sel) {
        var idx = parseInt(sel.getAttribute('data-option-index'), 10);
        if (isNaN(idx)) return;
        var name = peer && peer.optionNames && peer.optionNames[idx] ? peer.optionNames[idx] : String(idx);
        named[String(name).toLowerCase()] = sel.value;
      });
      return named;
    }

    function selectedTierRoot() {
      return root.querySelector('[data-bundle-tier].is-selected') || root;
    }

    function cartItems(variant) {
      var qty = currentBundleQty();
      var stepper = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      var scope = selectedTierRoot();
      // The page's own EU pick, for a line that shows the page piece.
      var pagePick = sizePicked && sizeOption ? sizeOption.querySelector('[data-option-size][data-eu].is-selected') : null;
      function propsFor(line, v) {
        var shown = lineEu(line);
        if (shown && v.options.indexOf(shown.maker) !== -1) return euProps(shown.eu, shown.maker);
        var handle = line && line.getAttribute('data-line-product');
        var pagePiece = !handle || !product || handle === product.handle;
        if (pagePiece && pagePick && Number(v.id) === Number(variant.id)) return euProps(pagePick.getAttribute('data-eu'), pagePick.getAttribute('data-value'), pageAdvice());
        return null;
      }
      if (qty <= 1) {
        var single = scope.querySelector('[data-bundle-line="1"]');
        var chosen = (single && variantFromLine(single)) || variant;
        var item = { id: Number(chosen.id), quantity: stepper };
        var props = propsFor(single, chosen);
        if (props) item.properties = props;
        return [item];
      }
      var items = [];
      var grouped = {};
      scope.querySelectorAll('[data-bundle-line]').forEach(function (line) {
        var index = parseInt(line.getAttribute('data-bundle-line'), 10) || 1;
        if (index > qty) return;
        var v = variantFromLine(line) || variant;
        if (!v) return;
        // Two EU sizes on one maker size are two cart lines, each with its own EU size.
        var lineProps = propsFor(line, v);
        var key = v.id + '|' + (lineProps ? lineProps._eu : '');
        if (!grouped[key]) {
          grouped[key] = { id: Number(v.id), quantity: 0 };
          if (lineProps) grouped[key].properties = lineProps;
          items.push(grouped[key]);
        }
        grouped[key].quantity += 1;
      });
      if (!items.length) items.push({ id: Number(variant.id), quantity: qty });
      return items;
    }

    function mixedVariants(items) {
      return items.length > 1;
    }

    function syncCartPayload(variant) {
      if (!form || !variant) return;
      var items = cartItems(variant);
      form.setAttribute('data-cart-items', JSON.stringify(items));
      if (shopPay) shopPay.classList.toggle('is-hidden', mixedVariants(items) || !sizePicked);
    }

    function updateVariant() {
      var v = findVariant();
      if (!v || !variantInput) return;
      variantInput.value = v.id;
      paintOptionUi();
      paintPrices(v);
      syncBundleLines(v);
      revealVariantMedia(v);
      if (atcBtn) {
        var canBuy = !!v.available && bundleLinesAvailable();
        atcBtn.disabled = !canBuy;
        var atcLabel = atcBtn.querySelector('[data-atc-label]');
        var atcText = canBuy ? addLabel : soldLabel;
        if (atcLabel) atcLabel.textContent = atcText;
        else atcBtn.textContent = atcText;
      }
      var stickyMeta = document.querySelector('[data-sticky-meta]');
      if (stickyMeta && product.options && product.options.length) {
        stickyMeta.textContent = sizePicked ? euTitle(v) : (root.getAttribute('data-choose-size') || v.title);
      }
      var stickyCompare = document.querySelector('[data-sticky-compare]');
      if (stickyCompare) {
        if (v.compare_at_price > v.price) {
          stickyCompare.hidden = false;
          stickyCompare.textContent = formatMoney(v.compare_at_price);
        } else {
          stickyCompare.hidden = true;
        }
      }
      var stickyThumb = document.querySelector('.sticky-atc__thumb img');
      var src = variantImage(v);
      // The rendered srcset still named the product photo and won over src, so
      // the bar showed another colour; 48 px needs the 160 px file, not the original.
      if (/\/cdn\/shop\/files\//.test(src)) src += (src.indexOf('?') === -1 ? '?' : '&') + 'width=160';
      else if (/\/assets\/g-/.test(src)) src = src.replace(/(\.[a-z0-9]+)(\?|$)/i, '_160x$1$2');
      if (stickyThumb && src) {
        stickyThumb.removeAttribute('srcset');
        stickyThumb.src = src;
      }
      syncCartPayload(v);
      document.dispatchEvent(new CustomEvent('belnay:variant-change', { detail: v }));
    }

    optionSelects.forEach(function (sel) {
      sel.addEventListener('change', updateVariant);
    });

    root.querySelectorAll('[data-option-swatch]').forEach(function (swatch) {
      swatch.addEventListener('mousedown', function (event) {
        if (event.button !== 0) return;
        var x = window.scrollX;
        var y = window.scrollY;
        requestAnimationFrame(function () {
          if (jumpToFirstPhoto) return;
          if (window.scrollX !== x || window.scrollY !== y) window.scrollTo(x, y);
        });
      });
      swatch.addEventListener('click', function () {
        var idx = parseInt(swatch.getAttribute('data-option-index'), 10);
        var value = swatch.getAttribute('data-value');
        setOptionValue(idx, value, false);
        syncPageLines(idx, value);
      });
    });

    root.querySelectorAll('[data-option-size]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-option-index'), 10);
        var value = btn.getAttribute('data-value');
        setOptionValue(idx, value, false);
        syncPageLines(idx, value, btn.getAttribute('data-eu'));
      });
    });

    root.querySelectorAll('[data-bundle-tier]').forEach(function (tier) {
      function selectTier() {
        /* The pair is the only box, so a second tap turns it off again:
           quantity back to 1 deselects every tier (change handler below). */
        if (tier.classList.contains('is-selected') && !root.querySelector('[data-bundle-tier][data-bundle-qty="1"]')) {
          if (qtyInput) {
            qtyInput.value = '1';
            qtyInput.dispatchEvent(new Event('change'));
          } else {
            tier.classList.remove('is-selected');
            tier.setAttribute('aria-checked', 'false');
            updateVariant();
          }
          return;
        }
        root.querySelectorAll('[data-bundle-tier]').forEach(function (t) {
          var on = t === tier;
          t.classList.toggle('is-selected', on);
          t.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        var qty = parseInt(tier.getAttribute('data-bundle-qty'), 10) || 1;
        if (qtyInput) {
          qtyInput.value = String(qty);
          qtyInput.dispatchEvent(new Event('change'));
        }
        updateVariant();
      }
      tier.addEventListener('click', function (event) {
        if (event.target.closest('select, option, a, button, input')) return;
        selectTier();
      });
      tier.addEventListener('keydown', function (event) {
        if (event.target.closest('select, option, a, button, input')) return;
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        selectTier();
      });
    });

    root.addEventListener('change', function (event) {
      var sel = event.target.closest && event.target.closest('[data-line-option]');
      if (!sel || !root.contains(sel)) return;
      var line = sel.closest('[data-bundle-line]');
      var lineIndex = line ? parseInt(line.getAttribute('data-bundle-line'), 10) : 0;
      var handle = line && line.getAttribute('data-line-product');
      var pagePiece = !handle || !product || handle === product.handle;
      if (lineIndex === 1 && pagePiece) {
        var idx = parseInt(sel.getAttribute('data-option-index'), 10);
        var chosenOpt = sel.options[sel.selectedIndex];
        if (chosenOpt && chosenOpt.hasAttribute('data-eu')) euPicked = chosenOpt.getAttribute('data-eu');
        setOptionValue(idx, sel.value, false);
      } else {
        updateVariant();
      }
    });

    root.addEventListener('click', function (event) {
      var peerBtn = event.target.closest('[data-bundle-peer]');
      if (!peerBtn || !root.contains(peerBtn)) return;
      event.preventDefault();
      event.stopPropagation();
      var handle = peerBtn.getAttribute('data-bundle-peer');
      var line = root.querySelector('[data-bundle-tier][data-bundle-qty="2"] [data-bundle-line="2"]');
      if (!line || !handle) return;
      peerBtn.setAttribute('aria-busy', 'true');
      var prefer = linePreference(line);
      // Keep the EU size the customer sees, not the maker label: makers grade differently.
      var pageBtn = sizeOption && sizeOption.querySelector('[data-option-size][data-eu].is-selected');
      var shown = lineEu(line) || (pageBtn ? { eu: pageBtn.getAttribute('data-eu') } : null);
      loadPeer(handle).then(function (peer) {
        peerBtn.removeAttribute('aria-busy');
        if (!peer) return;
        if (!peer.eu) peer.eu = euMap(peerBtn.getAttribute('data-bundle-peer-eu'));
        var match = shown && peer.eu && peer.eu.find(function (entry) { return entry.size === shown.eu; });
        if (shown && peer.eu) preferSize(prefer, match ? String(match.maker).split('·')[0].trim() : '');
        applyToLine(line, peer, chooseVariant(peer, prefer), match ? match.size : '');
      }).catch(function () {
        peerBtn.removeAttribute('aria-busy');
      });
    });

    document.addEventListener('belnay:bundle-apply', function (event) {
      var detail = event.detail || {};
      if (!detail.line || !root.contains(detail.line)) return;
      var peer = rememberPeer(detail.product);
      if (!peer) return;
      peer.eu = Array.isArray(detail.eu) && detail.eu.length ? detail.eu : null;
      var variant = (peer.variants || []).find(function (item) {
        return Number(item.id) === Number(detail.variantId);
      });
      if (variant) applyToLine(detail.line, peer, variant, detail.pick || '');
    });

    if (qtyInput) {
      qtyInput.addEventListener('change', function () {
        var n = Math.max(1, parseInt(qtyInput.value, 10) || 1);
        var match = root.querySelector('[data-bundle-tier][data-bundle-qty="' + n + '"]');
        root.querySelectorAll('[data-bundle-tier]').forEach(function (t) {
          var on = match ? t === match : parseInt(t.getAttribute('data-bundle-qty'), 10) === 1 && n === 1;
          t.classList.toggle('is-selected', on);
          t.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        if (!match && n > 1) {
          var two = root.querySelector('[data-bundle-tier][data-bundle-qty="2"]');
          if (two && n >= 2) {
            two.classList.add('is-selected');
            two.setAttribute('aria-checked', 'true');
            root.querySelectorAll('[data-bundle-tier]').forEach(function (t) {
              if (t !== two) {
                t.classList.remove('is-selected');
                t.setAttribute('aria-checked', 'false');
              }
            });
          }
        }
        updateVariant();
      });
    }

    var zoom = root.querySelector('[data-product-zoom]');
    var zoomScroller = zoom && zoom.querySelector('[data-zoom-scroller]');
    var zoomSlides = zoom ? zoom.querySelectorAll('[data-zoom-slide]') : [];
    var zoomThumbs = zoom ? zoom.querySelectorAll('[data-zoom-thumb]') : [];

    function setZoomThumb(index) {
      zoomThumbs.forEach(function (thumb, i) {
        thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    function scrollZoomTo(index, behavior) {
      var slide = zoomSlides[index];
      if (!slide) return;
      slide.scrollIntoView({ behavior: behavior || (reduced ? 'auto' : 'smooth'), block: 'start' });
      setZoomThumb(index);
    }

    function closeZoom() {
      if (!zoom || !zoom.open) return;
      if (typeof zoom.close === 'function') zoom.close();
      else zoom.removeAttribute('open');
    }

    function openZoom(index, event) {
      if (!zoom) return;
      var source = event && event.target && event.target.closest('[data-gallery-slide]');
      var target = zoomSlides[index];
      function show() {
        if (typeof zoom.showModal === 'function') zoom.showModal();
        else zoom.setAttribute('open', '');
        scrollZoomTo(index, 'auto');
        var closeBtn = zoom.querySelector('[data-zoom-close]');
        if (closeBtn) closeBtn.focus({ preventScroll: true });
      }
      var canTransition =
        !reduced &&
        source &&
        target &&
        typeof document.startViewTransition === 'function';
      if (!canTransition) {
        show();
        return;
      }
      var img = source.querySelector('img');
      var dest = target.querySelector('img') || target;
      if (img) img.style.viewTransitionName = 'gallery-item-open';
      document.startViewTransition(function () {
        if (img) img.style.viewTransitionName = '';
        dest.style.viewTransitionName = 'gallery-item-open';
        show();
      }).finished.finally(function () {
        dest.style.viewTransitionName = '';
      });
    }

    root.querySelectorAll('[data-gallery-slide]').forEach(function (slide) {
      slide.addEventListener('click', function (event) {
        if (galleryMoved) {
          galleryMoved = false;
          event.preventDefault();
          return;
        }
        if (phoneGallery() && coarsePointer) return;
        var index = parseInt(slide.getAttribute('data-gallery-index'), 10) || 0;
        var mediaId = slide.getAttribute('data-media-id');
        if (mediaId && zoom) {
          zoom.querySelectorAll('[data-zoom-slide]').forEach(function (zoomSlide, i) {
            if (zoomSlide.getAttribute('data-media-id') === mediaId) index = i;
          });
        }
        openZoom(index, event);
      });
    });

    if (zoom) {
      zoom.querySelectorAll('[data-zoom-close]').forEach(function (btn) {
        btn.addEventListener('click', closeZoom);
      });
      zoom.addEventListener('click', function (event) {
        if (event.target === zoom) closeZoom();
      });
      zoom.addEventListener('cancel', function (event) {
        event.preventDefault();
        closeZoom();
      });
      zoomThumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var index = parseInt(thumb.getAttribute('data-zoom-thumb'), 10) || 0;
          scrollZoomTo(index);
        });
      });
      if (zoomScroller && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          var best = null;
          entries.forEach(function (entry) {
            if (!best || entry.intersectionRatio > best.intersectionRatio) best = entry;
          });
          if (!best || !best.isIntersecting) return;
          var index = parseInt(best.target.getAttribute('data-zoom-slide'), 10);
          if (!isNaN(index)) setZoomThumb(index);
        }, { root: zoomScroller, threshold: 0.55 });
        zoomSlides.forEach(function (slide) { observer.observe(slide); });
      }
    }

    if (atcBtn) {
      atcBtn.addEventListener('click', function (event) {
        if (sizePicked) return;
        event.preventDefault();
        askForSize();
      });
    }

    /* The customer line glides to the reviews instead of jumping (owner, 25 Oct 2026). */
    // iOS Safari moves the fixed bars once its toolbar collapses mid-scroll, so
    // when the scroll stops, close the gap to the header's real bottom edge.
    function settleUnderHeader(target) {
      var header = document.querySelector('.header');
      header = header && header.closest('.shopify-section');
      if (!header) return;
      var lastY = -1, still = 0, frames = 0;
      (function settle() {
        still = window.scrollY === lastY ? still + 1 : 0;
        lastY = window.scrollY;
        if (still < 5 && ++frames < 180) return requestAnimationFrame(settle);
        var gap = target.getBoundingClientRect().top - header.getBoundingClientRect().bottom;
        if (Math.abs(gap) > 0.5) window.scrollBy({ top: gap, behavior: 'auto' });
      })();
    }
    var ratingLink = root.querySelector('.main-product__proof');
    if (ratingLink) {
      ratingLink.addEventListener('click', function (event) {
        var hash = ratingLink.getAttribute('href') || '';
        var target = hash.charAt(0) === '#' ? document.getElementById(hash.slice(1)) : null;
        if (!target) return;
        event.preventDefault();
        // Lands under the fixed bar + header via scroll-padding (phone) / scroll-margin (desktop).
        target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
        settleUnderHeader(target);
      });
    }
    // Quick view's rating link opens this page at #product-reviews.
    var hashTarget = location.hash === '#product-reviews' && document.getElementById('product-reviews');
    if (hashTarget) {
      if (document.readyState === 'complete') settleUnderHeader(hashTarget);
      else window.addEventListener('load', function () { settleUnderHeader(hashTarget); }, { once: true });
    }

    var sticky = document.querySelector('[data-sticky-atc]');
    if (sticky) {
      if (sticky.parentElement !== document.body) {
        document.querySelectorAll('body > [data-sticky-atc]').forEach(function (old) {
          if (old !== sticky) old.remove();
        });
        var y = window.scrollY;
        var html = document.documentElement;
        var prevBehavior = html.style.scrollBehavior;
        html.style.scrollBehavior = 'auto';
        document.body.appendChild(sticky);
        if ((window.scrollY || 0) !== y) window.scrollTo(0, y);
        html.style.scrollBehavior = prevBehavior;
      }
      var stickyVariant = sticky.querySelector('[data-sticky-variant-id]');
      var stickyQty = sticky.querySelector('[data-sticky-quantity]');
      var stickyPrice = sticky.querySelector('[data-sticky-price]');
      var stickyBtn = sticky.querySelector('[data-sticky-atc-btn]');
      function syncSticky() {
        if (variantInput && stickyVariant) stickyVariant.value = variantInput.value;
        if (qtyInput && stickyQty) stickyQty.value = qtyInput.value || '1';
        if (priceEl && stickyPrice) stickyPrice.textContent = priceEl.textContent;
        if (stickyBtn && atcBtn) {
          stickyBtn.disabled = atcBtn.disabled;
          var atcLabel = atcBtn.querySelector('[data-atc-label]');
          var stickyLabel = stickyBtn.querySelector('[data-atc-label]');
          if (atcLabel && stickyLabel) stickyLabel.textContent = atcLabel.textContent;
        }
        if (form && sticky.querySelector('form')) {
          sticky.querySelector('form').setAttribute('data-cart-items', form.getAttribute('data-cart-items') || '');
        }
      }
      // Until the visitor picks a size, the bar sends them to the sizes instead
      // of adding the first one. On click, not submit: cart.js catches submits
      // in the capture phase first.
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function (event) {
          if (sizePicked) return;
          event.preventDefault();
          askForSize();
        });
      }
      // Runs on every scroll frame: nodes are looked up once, and the DOM is
      // only written when the bar actually appears or leaves.
      var footer = document.querySelector('.footer') || document.querySelector('footer');
      var welcome = document.getElementById('welcome-pop');
      var mainAtc = document.querySelector('[data-main-atc]');
      var stickyShown = null;
      function paintStickyBar() {
        var gap = 20;
        var barH = sticky.offsetHeight || 56;
        var footerCovering = footer
          ? footer.getBoundingClientRect().top < window.innerHeight - gap - barH + 4
          : false;
        var blocked = document.body.classList.contains('cart-drawer-open')
          || document.body.classList.contains('search-modal-open')
          || document.body.classList.contains('nav-open')
          || (welcome && !welcome.hidden);
        // Sableau's moment (owner, 24 Oct 2026): the bar comes only once the real
        // button has been scrolled up out of view. Below the fold at page top = no bar.
        var buyOffScreen = !mainAtc || mainAtc.getBoundingClientRect().bottom <= 0;
        var show = buyOffScreen && !footerCovering && !blocked;
        if (show === stickyShown) return;
        stickyShown = show;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (show) syncSticky();
      }
      paintStickyBar();
      window.addEventListener('scroll', paintStickyBar, { passive: true });
      window.addEventListener('resize', paintStickyBar);
      if (window.MutationObserver) {
        new MutationObserver(paintStickyBar).observe(document.body, {
          attributes: true,
          attributeFilter: ['class']
        });
        var welcomePop = document.getElementById('welcome-pop');
        if (welcomePop) {
          new MutationObserver(paintStickyBar).observe(welcomePop, {
            attributes: true,
            attributeFilter: ['hidden']
          });
        }
      }
      if (qtyInput) qtyInput.addEventListener('change', syncSticky);
      document.addEventListener('belnay:variant-change', syncSticky);
    }

    if (window.Belnay && typeof window.Belnay.bindAccordions === 'function') {
      window.Belnay.bindAccordions(root);
    }

    updateVariant();
    allowMediaScroll = true;
    revealVariantMedia(findVariant());
    placeSizePills();
  }

  function scan(scope) {
    (scope || document).querySelectorAll('[data-main-product]').forEach(bindProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
})();
